import { ParsedUrlQuery } from 'querystring';

export const convertExamDetailQueryString = (query: ParsedUrlQuery) => {
  if (query.sorts === 'examDate,asc') {
    return { sorts: ['examDate,asc', 'examRound,asc'] };
  } else {
    return { sorts: ['examDate,desc', 'examRound,desc'] };
  }
};
